import { MessengerConnection } from './messenger-connection.js';
import { createConsoleLogger } from './../utils.js';

const logger = createConsoleLogger(true, 'IM:');
const connections = {};
let performerInRoom = {};

export class Messenger {

  constructor(storeController, edgeConnection) {
    this.storeController = storeController;
    this.edgeConnection = edgeConnection;
    this.promisesStartIM = {};
    this.needRestartAfterWsDisconnect = false;
    this.needRestartAfterPageReload = true;
  }

  getImAvailabilityParam() {
    const {
      user: { isGuest, settings: { s_private_message }, favorites }
    } = this.storeController.store.getState();

    let enabled = 0;
    let acceptModelsList = 'none';

    if (isGuest) return acceptModelsList;

    if (s_private_message == 0) {
      enabled = 1;
      acceptModelsList = 'all'
    } else if (s_private_message == 1) {
      enabled = 1;
      // const allowedPerformers = _uniq([
      //   ...friends.map(p => p.id),
      //   ...favorites.map(p => p.id)
      // ]);
      acceptModelsList = favorites.map(p => p.id).join(',');

      if (acceptModelsList == '') {
        // no friends, favorites yet
        enabled = 0;
        acceptModelsList = 'none';
      }
    }

    logger.info('getImAvailabilityParam()', enabled, acceptModelsList);
    return acceptModelsList;
  }

  setupAvailabilityPresence() {
    const { user } = this.storeController.store.getState();
    if (!user || user.isGuest) return;
    this.edgeConnection.send({
      action: 'presence_set_im_availability',
      im_availability: this.getImAvailabilityParam()
    });
  }

  setupAvailabilityChatRoom(room) {
    const { user } = this.storeController.store.getState();
    if (!user || user.isGuest) return;
    this.edgeConnection.send({
      action: 'set_im_availability',
      im_availability: this.getImAvailabilityParam(),
      room
    });
  }

  updatePrivateMessageSetting(val) {
    this.storeController.store.dispatch(this.storeController.user.actions.update_private_message_setting(val));
    this.setupAvailabilityPresence();
  }

  startMessenger(collocutor) {
    let isNew = true;
    const { user, messenger: { collocutors } } = this.storeController.store.getState();
    collocutors.some(c => {
      if (c.id == collocutor.id) {
        isNew = false;
        return true;
      }
    });
    if (isNew) {
      this.storeController.store.dispatch(this.storeController.messenger.actions.create_messenger(collocutor));
      // create new connection
      this.askPresenceToStartIm(collocutor).then(loginInfo => {
        const me = user;
        const mcKey = user.id + '_' + collocutor.id;
        if (!connections[mcKey]) {
          connections[mcKey] = new MessengerConnection(this, me, collocutor, loginInfo);
        }
        const conn = connections[mcKey];
        logger.info('connectInstMsgr', collocutor.username, loginInfo, conn);
        conn.login();
      });
    }

    if (0/*isPhone*/) this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_chatters_list());
    this.storeController.store.dispatch(this.storeController.messenger.actions.open_messenger(collocutor.id));
  }

  askPresenceToStartIm(performer) {
    const simple = simplePromise();
    this.promisesStartIM[performer.id] = simple;
    this.edgeConnection.send({ action: 'presence_start_im_chat', collocutor_id: performer.id });
    return simple.promise;
  }

  onImChatInfo(im_chat_info, collocutor, initiator_id) {
    const simple = this.promisesStartIM[collocutor.id];
    logger.log('onImChatInfo', im_chat_info, 'collocutor', collocutor, 'initiator_id', initiator_id, 'simple', simple);

    if (simple) {
      // we started the IM
      if (!im_chat_info) {
        simple.reject('absent im_chat_info for collocutor ' + collocutor.id);
      } else {
        simple.resolve(im_chat_info);
      }
      // forget promise
      delete this.promisesStartIM[collocutor.id];
    } else {
      // performer started the IM
      this.onInvitationToInstMsgr(im_chat_info, collocutor, initiator_id);
    }
  }

  onInvitationToInstMsgr(im_chat_info, collocutor, initiator_id) {
    const { user } = this.storeController.store.getState();
    this.storeController.store.dispatch(this.storeController.messenger.actions.create_messenger(collocutor));
    const me = user;
    const mcKey = me.id + '_' + collocutor.id;
    if (!connections[mcKey]) {
      connections[mcKey] = new MessengerConnection(this, me, collocutor, im_chat_info);
    }
    const conn = connections[mcKey];
    logger.info('connect to IM on performer invitation', collocutor.username, im_chat_info, conn);
    conn.login();
  }

  onConnectionHsmOnlineEnter(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.messenger_ready(collocutor.id));
  }

  onConnectionHsmOnlineExit(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.messenger_offline(collocutor.id));
  }

  onMessagesList(collocutor, messages) {
    logger.log('onMessagesList()', '(' + collocutor.username + ')', messages);

    messages = messages.map(m => ({
      username: m.senderName,
      message: m.content
    }));

    this.storeController.store.dispatch(this.storeController.messenger.actions.history({collocutorId: collocutor.id, messages}));

    if (this.restoreData) {
      this.restoreData.collocutors.forEach(c => {
        if (c.id == collocutor.id) {
          this.storeController.store.dispatch(this.storeController.messenger.actions.messenger_unread({collocutorId: c.id, unread: c.unread}));
        }
      })
    }

  }

  onNewMessage(collocutor, message) {
    logger.log('onNewMessage()', '(' + collocutor.username + ')', message, collocutor.id);
    message = {
      username: message.senderName,
      message: message.content
    };
    this.storeController.store.dispatch(this.storeController.messenger.actions.message({collocutor, message}));
  }

  onPerformerJoin(collocutorId) {
    performerInRoom[collocutorId] = true;
  }

  onPerformerLeave(collocutorId) {
    delete performerInRoom[collocutorId];
  }

  restartIfNeeded() {
    const { user, performers } = this.storeController.store.getState();
    if (!user || user.isGuest) return;

    if (this.needRestartAfterWsDisconnect) {
      // restart after websocket reconnect
      this.restart();
      return;
    }
    if (this.needRestartAfterPageReload) {
      // check if restart is needed after page reload
      const now = new Date().getTime();
      const data = localStorageGet('messenger');
      if (data && data.save_user_id == user.id && now - data.save_time < 60*60*1000) { // state updated less then 1 hour ago
        logger.log('restoreData', data);
        this.restoreData = data;

        if (data.muted) {
          this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_mute());
        }
        if (data.opened) {
          this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_chatters_list());
        }
        data.collocutors.forEach(collocutor => {
          let isOnline = false;
          performers.some(p => {
            if (collocutor.id == p.id) {
              isOnline = true;
              return true;
            }
          });
          if (!isOnline) return; // do not restore room for offline performer, it won't work

          this.storeController.store.dispatch(this.storeController.messenger.actions.create_messenger(collocutor));
          // create new connection
          this.askPresenceToStartIm(collocutor).then(loginInfo => {
            const me = user;
            const mcKey = user.id + '_' + collocutor.id;
            if (!connections[mcKey]) {
              connections[mcKey] = new MessengerConnection(this, me, collocutor, loginInfo);
            }
            const conn = connections[mcKey];
            logger.info('restart connectInstMsgr', collocutor.username, loginInfo, conn);
            conn.login();
          });
          if (collocutor.bar) {
            this.storeController.store.dispatch(this.storeController.messenger.actions.add_to_bar(collocutor.id));
          }
          if (collocutor.opened) {
            this.storeController.store.dispatch(this.storeController.messenger.actions.open_messenger(collocutor.id));
          }
        });

      }

      setTimeout(() => {
        this.restoreData = null;
      }, 10000);

      this.needRestartAfterPageReload = false;
    }
  }

  restart() {
    // after websocket reconnect
    logger.log('restart()');
    performerInRoom = {};
    Object.keys(connections).forEach(key => {
      logger.log('restart for key', key);
      connections[key].restart();
    });
  }

  toggleChattersList() {
    this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_chatters_list());
  }

  openChattersList() {
    this.storeController.store.dispatch(this.storeController.messenger.actions.open_chatters_list());
  }

  closeChattersList() {
    this.storeController.store.dispatch(this.storeController.messenger.actions.close_chatters_list());
  }

  openIMUnreadOrChattersList(preferredCollocutor) {
    const { messenger: { collocutors } } = this.storeController.store.getState();
    let unreadCol = false;
    let preferredFound = false;
    let totalUnread = 0;
    collocutors.forEach(c => {
      if (c.unread && !unreadCol) {
        unreadCol = c;
      }
      if (c.unread) totalUnread++;
      if (preferredCollocutor && preferredCollocutor.id == c.id) {
        preferredFound = true;
      }
    });
    if (unreadCol && totalUnread > 1) {
      this.openChattersList();
    } else if (unreadCol) {
      this.openMessenger(unreadCol);
    } else if (preferredCollocutor) {
      if (preferredFound) this.openMessenger(preferredCollocutor);
      else this.startMessenger(preferredCollocutor);
    } else {
      this.openChattersList();
    }
  }

  toggleMute() {
    this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_mute());
  }

  openMessenger(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.open_messenger(collocutor.id));
  }

  toggleMessenger(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.toggle_messenger(collocutor.id));
  }

  closeMessenger(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.close_messenger(collocutor.id));
  }

  hideFromBar(collocutor) {
    this.storeController.store.dispatch(this.storeController.messenger.actions.hide_from_bar(collocutor.id));
  }

  sendMessage(collocutor, text) {
    const { user } = this.storeController.store.getState();
    const me = user;
    const mcKey = me.id + '_' + collocutor.id;
    connections[mcKey].sendMessage(text);
    if (!performerInRoom[collocutor.id]) {
      logger.log('invite performer to room', collocutor.id);
      this.edgeConnection.send({ action: 'presence_send_im_chat_invitation', collocutor_id: collocutor.id });
    }
  }

}
